/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AbandonSubscriptionRestoreResponse } from '../models';
// @ts-ignore
import type { AddItemToCartInBulk } from '../models';
// @ts-ignore
import type { AddItemToCartResponse } from '../models';
// @ts-ignore
import type { AddNewStoreItemBody } from '../models';
// @ts-ignore
import type { AddNewStoreItemResponse } from '../models';
// @ts-ignore
import type { AdminCreateInvoice } from '../models';
// @ts-ignore
import type { AdminExcludeFromInvoiceSeriesBody } from '../models';
// @ts-ignore
import type { AdminExcludeFromInvoiceSeriesResponse } from '../models';
// @ts-ignore
import type { AdminSupportRedeemBody } from '../models';
// @ts-ignore
import type { AdminSupportRedeemResponse } from '../models';
// @ts-ignore
import type { AdminUpdateTrasnsactionBody } from '../models';
// @ts-ignore
import type { AdminUpdateTrasnsactionResponse } from '../models';
// @ts-ignore
import type { BuySpotlightWithCreditsBody } from '../models';
// @ts-ignore
import type { BuySpotlightWithCreditsResponse } from '../models';
// @ts-ignore
import type { CancelPaymentBody } from '../models';
// @ts-ignore
import type { CancelPaymentResponse } from '../models';
// @ts-ignore
import type { CancelSubscriptionBody } from '../models';
// @ts-ignore
import type { CancelSubscriptionResponse } from '../models';
// @ts-ignore
import type { CartCheckoutBody } from '../models';
// @ts-ignore
import type { CartCheckoutResponse } from '../models';
// @ts-ignore
import type { ClaimOrderVoucherResponse } from '../models';
// @ts-ignore
import type { ConfirmExternalCancelResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FinishPaymentBody } from '../models';
// @ts-ignore
import type { GetAdminOrdersByTrasnsactionIdResponse } from '../models';
// @ts-ignore
import type { GetAdminOrdersResponse } from '../models';
// @ts-ignore
import type { GetAdminSubscriptionsResponse } from '../models';
// @ts-ignore
import type { GetCartResponse } from '../models';
// @ts-ignore
import type { GetJobItemResponse } from '../models';
// @ts-ignore
import type { GetMySubscriptionResponse } from '../models';
// @ts-ignore
import type { GetOrgTransactionsDataResponse } from '../models';
// @ts-ignore
import type { GetShippingAddressResponse } from '../models';
// @ts-ignore
import type { GetSpotlightPurchaseSummaryResponse } from '../models';
// @ts-ignore
import type { GetSpotlightSocialProofResponse } from '../models';
// @ts-ignore
import type { GetStoreItemTypeCountsResponse } from '../models';
// @ts-ignore
import type { GetStoreItemsAdminResponse } from '../models';
// @ts-ignore
import type { GetStoreItemsResponse } from '../models';
// @ts-ignore
import type { GetSubscriptionInvoicesResponse } from '../models';
// @ts-ignore
import type { GetVoucherStatsResponse } from '../models';
// @ts-ignore
import type { IapConfirmBody } from '../models';
// @ts-ignore
import type { IapConfirmResponse } from '../models';
// @ts-ignore
import type { IapInitiateBody } from '../models';
// @ts-ignore
import type { IapInitiateResponse } from '../models';
// @ts-ignore
import type { ItemSyncStatusResponse } from '../models';
// @ts-ignore
import type { LogPaymentFunnelEventBody } from '../models';
// @ts-ignore
import type { OrderVoucherResponse } from '../models';
// @ts-ignore
import type { PremiumPromoPreflightResponse } from '../models';
// @ts-ignore
import type { PremiumPromoPreviewResponse } from '../models';
// @ts-ignore
import type { PremiumPromoSendBody } from '../models';
// @ts-ignore
import type { PremiumPromoSendResponse } from '../models';
// @ts-ignore
import type { ReconcileSubscriptionsResponse } from '../models';
// @ts-ignore
import type { RedeliverOrderResponse } from '../models';
// @ts-ignore
import type { RestoreSubscriptionResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { SyncStoreItemBody } from '../models';
// @ts-ignore
import type { SyncSubscriptionResponse } from '../models';
// @ts-ignore
import type { UpdateCartBody } from '../models';
// @ts-ignore
import type { UpdateCartResponse } from '../models';
// @ts-ignore
import type { UpdateStoreItemResponse } from '../models';
// @ts-ignore
import type { UploadItemImageResponse } from '../models';
// @ts-ignore
import type { UpsertAddressBody } from '../models';
// @ts-ignore
import type { UpsertAddressResponse } from '../models';
// @ts-ignore
import type { UpsertShippingAddressBody } from '../models';
// @ts-ignore
import type { UpsertShippingAddressResponse } from '../models';
// @ts-ignore
import type { UserOfferResponseBody } from '../models';
/**
 * PaymentApiApi - axios parameter creator
 */
export const PaymentApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAbandonSubscriptionRestore: async (subscriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('paymentApiAbandonSubscriptionRestore', 'subscriptionId', subscriptionId)
            const localVarPath = `/subscription/{subscription_id}/restore/abandon`
                .replace('{subscription_id}', encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddItemToCartInBulk} addItemToCartInBulk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAddItemToCart: async (addItemToCartInBulk: AddItemToCartInBulk, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addItemToCartInBulk' is not null or undefined
            assertParamExists('paymentApiAddItemToCart', 'addItemToCartInBulk', addItemToCartInBulk)
            const localVarPath = `/cart/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addItemToCartInBulk, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddNewStoreItemBody} addNewStoreItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAddNewItem: async (addNewStoreItemBody: AddNewStoreItemBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addNewStoreItemBody' is not null or undefined
            assertParamExists('paymentApiAddNewItem', 'addNewStoreItemBody', addNewStoreItemBody)
            const localVarPath = `/admin/store/item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addNewStoreItemBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminCreateInvoice} adminCreateInvoice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminCreateInvoice: async (adminCreateInvoice: AdminCreateInvoice, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCreateInvoice' is not null or undefined
            assertParamExists('paymentApiAdminCreateInvoice', 'adminCreateInvoice', adminCreateInvoice)
            const localVarPath = `/admin/create-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateInvoice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminExcludeFromInvoiceSeriesBody} adminExcludeFromInvoiceSeriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminExcludeFromInvoiceSeries: async (adminExcludeFromInvoiceSeriesBody: AdminExcludeFromInvoiceSeriesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminExcludeFromInvoiceSeriesBody' is not null or undefined
            assertParamExists('paymentApiAdminExcludeFromInvoiceSeries', 'adminExcludeFromInvoiceSeriesBody', adminExcludeFromInvoiceSeriesBody)
            const localVarPath = `/admin/exclude-from-invoice-series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminExcludeFromInvoiceSeriesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminGetUserShippingDetails: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('paymentApiAdminGetUserShippingDetails', 'userId', userId)
            const localVarPath = `/admin/payment/{user_id}/address`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {PaymentApiAdminListSubscriptionsStatusEnum} [status] 
         * @param {string | null} [userSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminListSubscriptions: async (page?: number | null, pageSize?: number | null, status?: PaymentApiAdminListSubscriptionsStatusEnum, userSearch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (userSearch !== undefined) {
                localVarQueryParameter['user_search'] = userSearch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminReconcileSubscriptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/subscriptions/reconcile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminSupportRedeemBody} adminSupportRedeemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminSupportRedeem: async (adminSupportRedeemBody: AdminSupportRedeemBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSupportRedeemBody' is not null or undefined
            assertParamExists('paymentApiAdminSupportRedeem', 'adminSupportRedeemBody', adminSupportRedeemBody)
            const localVarPath = `/admin/store/support-redeem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSupportRedeemBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminSyncSubscription: async (subscriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('paymentApiAdminSyncSubscription', 'subscriptionId', subscriptionId)
            const localVarPath = `/admin/subscription/{subscription_id}/sync`
                .replace('{subscription_id}', encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiBackfillPaymentResults: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/store/backfill-payment-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BuySpotlightWithCreditsBody} buySpotlightWithCreditsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiBuySpotlightWithCredits: async (buySpotlightWithCreditsBody: BuySpotlightWithCreditsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buySpotlightWithCreditsBody' is not null or undefined
            assertParamExists('paymentApiBuySpotlightWithCredits', 'buySpotlightWithCreditsBody', buySpotlightWithCreditsBody)
            const localVarPath = `/spotlight/buy-with-credits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buySpotlightWithCreditsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {CancelSubscriptionBody} cancelSubscriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiCancelMySubscription: async (subscriptionId: string, cancelSubscriptionBody: CancelSubscriptionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('paymentApiCancelMySubscription', 'subscriptionId', subscriptionId)
            // verify required parameter 'cancelSubscriptionBody' is not null or undefined
            assertParamExists('paymentApiCancelMySubscription', 'cancelSubscriptionBody', cancelSubscriptionBody)
            const localVarPath = `/subscription/{subscription_id}/cancel`
                .replace('{subscription_id}', encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelSubscriptionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CancelPaymentBody} cancelPaymentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiCancelTransaction: async (cancelPaymentBody: CancelPaymentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancelPaymentBody' is not null or undefined
            assertParamExists('paymentApiCancelTransaction', 'cancelPaymentBody', cancelPaymentBody)
            const localVarPath = `/payment/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelPaymentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiClaimOrderVoucher: async (transactionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('paymentApiClaimOrderVoucher', 'transactionId', transactionId)
            const localVarPath = `/order/{transaction_id}/voucher/claim`
                .replace('{transaction_id}', encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FinishPaymentBody} finishPaymentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiCompleteTransaction: async (finishPaymentBody: FinishPaymentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'finishPaymentBody' is not null or undefined
            assertParamExists('paymentApiCompleteTransaction', 'finishPaymentBody', finishPaymentBody)
            const localVarPath = `/payment/finish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finishPaymentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiConfirmExternalSubscriptionCancel: async (subscriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('paymentApiConfirmExternalSubscriptionCancel', 'subscriptionId', subscriptionId)
            const localVarPath = `/subscription/{subscription_id}/cancel-notice/confirm`
                .replace('{subscription_id}', encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cartItemId] 
         * @param {number} [quantity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiDeleteCartItem: async (cartItemId?: string, quantity?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cart/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cartItemId !== undefined) {
                localVarQueryParameter['cart_item_id'] = cartItemId;
            }

            if (quantity !== undefined) {
                localVarQueryParameter['quantity'] = quantity;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiDeleteItem: async (itemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('paymentApiDeleteItem', 'itemId', itemId)
            const localVarPath = `/admin/store/item/{item_id}`
                .replace('{item_id}', encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaymentApiGetAdminOrderInvoiceKindEnum} kind 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetAdminOrderInvoice: async (kind: PaymentApiGetAdminOrderInvoiceKindEnum, transactionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('paymentApiGetAdminOrderInvoice', 'kind', kind)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('paymentApiGetAdminOrderInvoice', 'transactionId', transactionId)
            const localVarPath = `/admin/orders/{transaction_id}/invoice`
                .replace('{transaction_id}', encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaymentApiGetAllItemsAdminAvailableToEnum} [availableTo] 
         * @param {boolean | null} [isOfferItem] 
         * @param {boolean | null} [isReward] 
         * @param {string} [itemId] 
         * @param {PaymentApiGetAllItemsAdminItemTypeEnum} [itemType] 
         * @param {boolean | null} [untyped] 
         * @param {string} [userSearchQuery] 
         * @param {boolean | null} [webIsActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetAllItemsAdmin: async (availableTo?: PaymentApiGetAllItemsAdminAvailableToEnum, isOfferItem?: boolean | null, isReward?: boolean | null, itemId?: string, itemType?: PaymentApiGetAllItemsAdminItemTypeEnum, untyped?: boolean | null, userSearchQuery?: string, webIsActive?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/store/item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (availableTo !== undefined) {
                localVarQueryParameter['available_to'] = availableTo;
            }

            if (isOfferItem !== undefined) {
                localVarQueryParameter['is_offer_item'] = isOfferItem;
            }

            if (isReward !== undefined) {
                localVarQueryParameter['is_reward'] = isReward;
            }

            if (itemId !== undefined) {
                localVarQueryParameter['item_id'] = itemId;
            }

            if (itemType !== undefined) {
                localVarQueryParameter['item_type'] = itemType;
            }

            if (untyped !== undefined) {
                localVarQueryParameter['untyped'] = untyped;
            }

            if (userSearchQuery !== undefined) {
                localVarQueryParameter['user_search_query'] = userSearchQuery;
            }

            if (webIsActive !== undefined) {
                localVarQueryParameter['web_is_active'] = webIsActive;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [availableTo] 
         * @param {string} [itemId] 
         * @param {PaymentApiGetAllItemsPublicOfferMomentEnum} [offerMoment] 
         * @param {boolean} [openOffer] 
         * @param {string | null} [planId] 
         * @param {string | null} [platform] 
         * @param {boolean} [showActiveOffers] 
         * @param {boolean | null} [showAll] 
         * @param {boolean} [supportsSubscription] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetAllItemsPublic: async (availableTo?: string, itemId?: string, offerMoment?: PaymentApiGetAllItemsPublicOfferMomentEnum, openOffer?: boolean, planId?: string | null, platform?: string | null, showActiveOffers?: boolean, showAll?: boolean | null, supportsSubscription?: boolean, userSearchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/store/item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (availableTo !== undefined) {
                localVarQueryParameter['available_to'] = availableTo;
            }

            if (itemId !== undefined) {
                localVarQueryParameter['item_id'] = itemId;
            }

            if (offerMoment !== undefined) {
                localVarQueryParameter['offer_moment'] = offerMoment;
            }

            if (openOffer !== undefined) {
                localVarQueryParameter['open_offer'] = openOffer;
            }

            if (planId !== undefined) {
                localVarQueryParameter['plan_id'] = planId;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (showActiveOffers !== undefined) {
                localVarQueryParameter['show_active_offers'] = showActiveOffers;
            }

            if (showAll !== undefined) {
                localVarQueryParameter['show_all'] = showAll;
            }

            if (supportsSubscription !== undefined) {
                localVarQueryParameter['supports_subscription'] = supportsSubscription;
            }

            if (userSearchQuery !== undefined) {
                localVarQueryParameter['user_search_query'] = userSearchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [couponCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetAllJobItems: async (couponCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/store/job/item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (couponCode !== undefined) {
                localVarQueryParameter['coupon_code'] = couponCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [paymentMode] 
         * @param {string} [paymentStatus] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetAllOrders: async (endDate?: string, pageNo?: number, pageSize?: number, paymentMode?: string, paymentStatus?: string, startDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (paymentMode !== undefined) {
                localVarQueryParameter['payment_mode'] = paymentMode;
            }

            if (paymentStatus !== undefined) {
                localVarQueryParameter['payment_status'] = paymentStatus;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetCart: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetMySubscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscription/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetOrderById: async (transactionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('paymentApiGetOrderById', 'transactionId', transactionId)
            const localVarPath = `/admin/orders/{transaction_id}`
                .replace('{transaction_id}', encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetOrderVoucherStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/order/voucher-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetOrgTransactionsData: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('paymentApiGetOrgTransactionsData', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/transactions-data`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetSpotlightPurchaseSummary: async (transactionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('paymentApiGetSpotlightPurchaseSummary', 'transactionId', transactionId)
            const localVarPath = `/spotlight/purchase-summary/{transaction_id}`
                .replace('{transaction_id}', encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetSpotlightSocialProof: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/spotlight/social-proof`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetStoreItemSyncStatus: async (itemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('paymentApiGetStoreItemSyncStatus', 'itemId', itemId)
            const localVarPath = `/admin/store/item/{item_id}/sync-status`
                .replace('{item_id}', encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetStoreItemTypeCounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/store/item-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetSubscriptionInvoices: async (subscriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('paymentApiGetSubscriptionInvoices', 'subscriptionId', subscriptionId)
            const localVarPath = `/subscription/{subscription_id}/invoices`
                .replace('{subscription_id}', encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetUserAddressDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payment/address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetUserShippingDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payment/shipping-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IapConfirmBody} iapConfirmBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiIapConfirm: async (iapConfirmBody: IapConfirmBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iapConfirmBody' is not null or undefined
            assertParamExists('paymentApiIapConfirm', 'iapConfirmBody', iapConfirmBody)
            const localVarPath = `/payment/iap/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iapConfirmBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IapInitiateBody} iapInitiateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiIapInitiate: async (iapInitiateBody: IapInitiateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iapInitiateBody' is not null or undefined
            assertParamExists('paymentApiIapInitiate', 'iapInitiateBody', iapInitiateBody)
            const localVarPath = `/payment/iap/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iapInitiateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LogPaymentFunnelEventBody} logPaymentFunnelEventBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiLogPaymentFunnelEvent: async (logPaymentFunnelEventBody: LogPaymentFunnelEventBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logPaymentFunnelEventBody' is not null or undefined
            assertParamExists('paymentApiLogPaymentFunnelEvent', 'logPaymentFunnelEventBody', logPaymentFunnelEventBody)
            const localVarPath = `/payment/funnel-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logPaymentFunnelEventBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CartCheckoutBody} cartCheckoutBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiMakePayment: async (cartCheckoutBody: CartCheckoutBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCheckoutBody' is not null or undefined
            assertParamExists('paymentApiMakePayment', 'cartCheckoutBody', cartCheckoutBody)
            const localVarPath = `/cart/checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cartCheckoutBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [discountPercents] 
         * @param {string | null} [itemId] 
         * @param {number | null} [loginWithinDays] 
         * @param {number | null} [maxCredits] 
         * @param {number | null} [minLogins] 
         * @param {number | null} [offerHours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiPremiumPromoPreflight: async (discountPercents?: string | null, itemId?: string | null, loginWithinDays?: number | null, maxCredits?: number | null, minLogins?: number | null, offerHours?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/store/premium-promo/preflight`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (discountPercents !== undefined) {
                localVarQueryParameter['discount_percents'] = discountPercents;
            }

            if (itemId !== undefined) {
                localVarQueryParameter['item_id'] = itemId;
            }

            if (loginWithinDays !== undefined) {
                localVarQueryParameter['login_within_days'] = loginWithinDays;
            }

            if (maxCredits !== undefined) {
                localVarQueryParameter['max_credits'] = maxCredits;
            }

            if (minLogins !== undefined) {
                localVarQueryParameter['min_logins'] = minLogins;
            }

            if (offerHours !== undefined) {
                localVarQueryParameter['offer_hours'] = offerHours;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number | null} [discountPercent] 
         * @param {string | null} [itemId] 
         * @param {number | null} [offerHours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiPremiumPromoPreview: async (discountPercent?: number | null, itemId?: string | null, offerHours?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/store/premium-promo/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (discountPercent !== undefined) {
                localVarQueryParameter['discount_percent'] = discountPercent;
            }

            if (itemId !== undefined) {
                localVarQueryParameter['item_id'] = itemId;
            }

            if (offerHours !== undefined) {
                localVarQueryParameter['offer_hours'] = offerHours;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiRedeliverOrder: async (transactionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('paymentApiRedeliverOrder', 'transactionId', transactionId)
            const localVarPath = `/admin/orders/{transaction_id}/redeliver`
                .replace('{transaction_id}', encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiRefreshStoreItemAppleStatus: async (itemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('paymentApiRefreshStoreItemAppleStatus', 'itemId', itemId)
            const localVarPath = `/admin/store/item/{item_id}/refresh-apple-status`
                .replace('{item_id}', encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiRestoreMySubscription: async (subscriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('paymentApiRestoreMySubscription', 'subscriptionId', subscriptionId)
            const localVarPath = `/subscription/{subscription_id}/restore`
                .replace('{subscription_id}', encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PremiumPromoSendBody} premiumPromoSendBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiSendPremiumPromoEmail: async (premiumPromoSendBody: PremiumPromoSendBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'premiumPromoSendBody' is not null or undefined
            assertParamExists('paymentApiSendPremiumPromoEmail', 'premiumPromoSendBody', premiumPromoSendBody)
            const localVarPath = `/admin/store/premium-promo/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(premiumPromoSendBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiSubmitStoreItemAppleReview: async (itemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('paymentApiSubmitStoreItemAppleReview', 'itemId', itemId)
            const localVarPath = `/admin/store/item/{item_id}/submit-apple-review`
                .replace('{item_id}', encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} itemId 
         * @param {SyncStoreItemBody} syncStoreItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiSyncStoreItem: async (itemId: string, syncStoreItemBody: SyncStoreItemBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('paymentApiSyncStoreItem', 'itemId', itemId)
            // verify required parameter 'syncStoreItemBody' is not null or undefined
            assertParamExists('paymentApiSyncStoreItem', 'syncStoreItemBody', syncStoreItemBody)
            const localVarPath = `/admin/store/item/{item_id}/sync`
                .replace('{item_id}', encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncStoreItemBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<UpdateCartBody>} updateCartBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUpdateCartItems: async (updateCartBody: Array<UpdateCartBody>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCartBody' is not null or undefined
            assertParamExists('paymentApiUpdateCartItems', 'updateCartBody', updateCartBody)
            const localVarPath = `/cart/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCartBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} itemId 
         * @param {AddNewStoreItemBody} addNewStoreItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUpdatePurchasableItems: async (itemId: string, addNewStoreItemBody: AddNewStoreItemBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('paymentApiUpdatePurchasableItems', 'itemId', itemId)
            // verify required parameter 'addNewStoreItemBody' is not null or undefined
            assertParamExists('paymentApiUpdatePurchasableItems', 'addNewStoreItemBody', addNewStoreItemBody)
            const localVarPath = `/admin/store/item/{item_id}`
                .replace('{item_id}', encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addNewStoreItemBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {AdminUpdateTrasnsactionBody} adminUpdateTrasnsactionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUpdateTransactionDetails: async (transactionId: string, adminUpdateTrasnsactionBody: AdminUpdateTrasnsactionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('paymentApiUpdateTransactionDetails', 'transactionId', transactionId)
            // verify required parameter 'adminUpdateTrasnsactionBody' is not null or undefined
            assertParamExists('paymentApiUpdateTransactionDetails', 'adminUpdateTrasnsactionBody', adminUpdateTrasnsactionBody)
            const localVarPath = `/admin/update-transaction/{transaction_id}`
                .replace('{transaction_id}', encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateTrasnsactionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUploadItemImage: async (imageFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageFile' is not null or undefined
            assertParamExists('paymentApiUploadItemImage', 'imageFile', imageFile)
            const localVarPath = `/store/item/upload-item-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (imageFile !== undefined) { 
                localVarFormParams.append('image_file', imageFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {File | null} [imageFile] 
         * @param {string} [description] 
         * @param {string | null} [giftCardCode] 
         * @param {string | null} [pin] 
         * @param {string | null} [expiresAt] 
         * @param {string | null} [redemptionLink] 
         * @param {boolean} [removeImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUploadOrderVoucher: async (transactionId: string, imageFile?: File | null, description?: string, giftCardCode?: string | null, pin?: string | null, expiresAt?: string | null, redemptionLink?: string | null, removeImage?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('paymentApiUploadOrderVoucher', 'transactionId', transactionId)
            const localVarPath = `/admin/order/{transaction_id}/voucher`
                .replace('{transaction_id}', encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (imageFile !== undefined) { 
                localVarFormParams.append('image_file', imageFile as any);
            }

            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }

            if (giftCardCode !== undefined) { 
                localVarFormParams.append('gift_card_code', giftCardCode as any);
            }

            if (pin !== undefined) { 
                localVarFormParams.append('pin', pin as any);
            }

            if (expiresAt !== undefined) { 
                localVarFormParams.append('expires_at', expiresAt as any);
            }

            if (redemptionLink !== undefined) { 
                localVarFormParams.append('redemption_link', redemptionLink as any);
            }

            if (removeImage !== undefined) { 
                localVarFormParams.append('remove_image', String(removeImage) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} itemId 
         * @param {File} [imageFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUploadStoreItemAppleReviewScreenshot: async (itemId: string, imageFile?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('paymentApiUploadStoreItemAppleReviewScreenshot', 'itemId', itemId)
            const localVarPath = `/admin/store/item/{item_id}/upload-apple-review-screenshot`
                .replace('{item_id}', encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (imageFile !== undefined) { 
                localVarFormParams.append('image_file', imageFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertAddressBody} upsertAddressBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUpsertUserAddressDetails: async (upsertAddressBody: UpsertAddressBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertAddressBody' is not null or undefined
            assertParamExists('paymentApiUpsertUserAddressDetails', 'upsertAddressBody', upsertAddressBody)
            const localVarPath = `/payment/address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertAddressBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertShippingAddressBody} upsertShippingAddressBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUpsertUserShippingDetails: async (upsertShippingAddressBody: UpsertShippingAddressBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertShippingAddressBody' is not null or undefined
            assertParamExists('paymentApiUpsertUserShippingDetails', 'upsertShippingAddressBody', upsertShippingAddressBody)
            const localVarPath = `/payment/shipping-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertShippingAddressBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserOfferResponseBody} userOfferResponseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUserOfferItemResponse: async (userOfferResponseBody: UserOfferResponseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userOfferResponseBody' is not null or undefined
            assertParamExists('paymentApiUserOfferItemResponse', 'userOfferResponseBody', userOfferResponseBody)
            const localVarPath = `/store/item/offer/response`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userOfferResponseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUserOrderHistory: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payment/order-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentApiApi - functional programming interface
 */
export const PaymentApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiAbandonSubscriptionRestore(subscriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbandonSubscriptionRestoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiAbandonSubscriptionRestore(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiAbandonSubscriptionRestore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddItemToCartInBulk} addItemToCartInBulk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiAddItemToCart(addItemToCartInBulk: AddItemToCartInBulk, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddItemToCartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiAddItemToCart(addItemToCartInBulk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiAddItemToCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddNewStoreItemBody} addNewStoreItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiAddNewItem(addNewStoreItemBody: AddNewStoreItemBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddNewStoreItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiAddNewItem(addNewStoreItemBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiAddNewItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminCreateInvoice} adminCreateInvoice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiAdminCreateInvoice(adminCreateInvoice: AdminCreateInvoice, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiAdminCreateInvoice(adminCreateInvoice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiAdminCreateInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminExcludeFromInvoiceSeriesBody} adminExcludeFromInvoiceSeriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiAdminExcludeFromInvoiceSeries(adminExcludeFromInvoiceSeriesBody: AdminExcludeFromInvoiceSeriesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminExcludeFromInvoiceSeriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiAdminExcludeFromInvoiceSeries(adminExcludeFromInvoiceSeriesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiAdminExcludeFromInvoiceSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiAdminGetUserShippingDetails(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiAdminGetUserShippingDetails(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiAdminGetUserShippingDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {PaymentApiAdminListSubscriptionsStatusEnum} [status] 
         * @param {string | null} [userSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiAdminListSubscriptions(page?: number | null, pageSize?: number | null, status?: PaymentApiAdminListSubscriptionsStatusEnum, userSearch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminSubscriptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiAdminListSubscriptions(page, pageSize, status, userSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiAdminListSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiAdminReconcileSubscriptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReconcileSubscriptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiAdminReconcileSubscriptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiAdminReconcileSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminSupportRedeemBody} adminSupportRedeemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiAdminSupportRedeem(adminSupportRedeemBody: AdminSupportRedeemBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSupportRedeemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiAdminSupportRedeem(adminSupportRedeemBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiAdminSupportRedeem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiAdminSyncSubscription(subscriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiAdminSyncSubscription(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiAdminSyncSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiBackfillPaymentResults(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiBackfillPaymentResults(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiBackfillPaymentResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BuySpotlightWithCreditsBody} buySpotlightWithCreditsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiBuySpotlightWithCredits(buySpotlightWithCreditsBody: BuySpotlightWithCreditsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuySpotlightWithCreditsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiBuySpotlightWithCredits(buySpotlightWithCreditsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiBuySpotlightWithCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {CancelSubscriptionBody} cancelSubscriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiCancelMySubscription(subscriptionId: string, cancelSubscriptionBody: CancelSubscriptionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiCancelMySubscription(subscriptionId, cancelSubscriptionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiCancelMySubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CancelPaymentBody} cancelPaymentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiCancelTransaction(cancelPaymentBody: CancelPaymentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiCancelTransaction(cancelPaymentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiCancelTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiClaimOrderVoucher(transactionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimOrderVoucherResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiClaimOrderVoucher(transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiClaimOrderVoucher']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FinishPaymentBody} finishPaymentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiCompleteTransaction(finishPaymentBody: FinishPaymentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiCompleteTransaction(finishPaymentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiCompleteTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiConfirmExternalSubscriptionCancel(subscriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmExternalCancelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiConfirmExternalSubscriptionCancel(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiConfirmExternalSubscriptionCancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [cartItemId] 
         * @param {number} [quantity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiDeleteCartItem(cartItemId?: string, quantity?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiDeleteCartItem(cartItemId, quantity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiDeleteCartItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiDeleteItem(itemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiDeleteItem(itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiDeleteItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaymentApiGetAdminOrderInvoiceKindEnum} kind 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetAdminOrderInvoice(kind: PaymentApiGetAdminOrderInvoiceKindEnum, transactionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetAdminOrderInvoice(kind, transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetAdminOrderInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaymentApiGetAllItemsAdminAvailableToEnum} [availableTo] 
         * @param {boolean | null} [isOfferItem] 
         * @param {boolean | null} [isReward] 
         * @param {string} [itemId] 
         * @param {PaymentApiGetAllItemsAdminItemTypeEnum} [itemType] 
         * @param {boolean | null} [untyped] 
         * @param {string} [userSearchQuery] 
         * @param {boolean | null} [webIsActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetAllItemsAdmin(availableTo?: PaymentApiGetAllItemsAdminAvailableToEnum, isOfferItem?: boolean | null, isReward?: boolean | null, itemId?: string, itemType?: PaymentApiGetAllItemsAdminItemTypeEnum, untyped?: boolean | null, userSearchQuery?: string, webIsActive?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStoreItemsAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetAllItemsAdmin(availableTo, isOfferItem, isReward, itemId, itemType, untyped, userSearchQuery, webIsActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetAllItemsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [availableTo] 
         * @param {string} [itemId] 
         * @param {PaymentApiGetAllItemsPublicOfferMomentEnum} [offerMoment] 
         * @param {boolean} [openOffer] 
         * @param {string | null} [planId] 
         * @param {string | null} [platform] 
         * @param {boolean} [showActiveOffers] 
         * @param {boolean | null} [showAll] 
         * @param {boolean} [supportsSubscription] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetAllItemsPublic(availableTo?: string, itemId?: string, offerMoment?: PaymentApiGetAllItemsPublicOfferMomentEnum, openOffer?: boolean, planId?: string | null, platform?: string | null, showActiveOffers?: boolean, showAll?: boolean | null, supportsSubscription?: boolean, userSearchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStoreItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetAllItemsPublic(availableTo, itemId, offerMoment, openOffer, planId, platform, showActiveOffers, showAll, supportsSubscription, userSearchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetAllItemsPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [couponCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetAllJobItems(couponCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetAllJobItems(couponCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetAllJobItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [paymentMode] 
         * @param {string} [paymentStatus] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetAllOrders(endDate?: string, pageNo?: number, pageSize?: number, paymentMode?: string, paymentStatus?: string, startDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminOrdersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetAllOrders(endDate, pageNo, pageSize, paymentMode, paymentStatus, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetAllOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetCart(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetCart(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetMySubscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMySubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetMySubscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetMySubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetOrderById(transactionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminOrdersByTrasnsactionIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetOrderById(transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetOrderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetOrderVoucherStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVoucherStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetOrderVoucherStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetOrderVoucherStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetOrgTransactionsData(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrgTransactionsDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetOrgTransactionsData(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetOrgTransactionsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetSpotlightPurchaseSummary(transactionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpotlightPurchaseSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetSpotlightPurchaseSummary(transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetSpotlightPurchaseSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetSpotlightSocialProof(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpotlightSocialProofResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetSpotlightSocialProof(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetSpotlightSocialProof']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetStoreItemSyncStatus(itemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemSyncStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetStoreItemSyncStatus(itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetStoreItemSyncStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetStoreItemTypeCounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStoreItemTypeCountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetStoreItemTypeCounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetStoreItemTypeCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetSubscriptionInvoices(subscriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSubscriptionInvoicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetSubscriptionInvoices(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetSubscriptionInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetUserAddressDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetUserAddressDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetUserAddressDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiGetUserShippingDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetShippingAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiGetUserShippingDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiGetUserShippingDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IapConfirmBody} iapConfirmBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiIapConfirm(iapConfirmBody: IapConfirmBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IapConfirmResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiIapConfirm(iapConfirmBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiIapConfirm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IapInitiateBody} iapInitiateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiIapInitiate(iapInitiateBody: IapInitiateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IapInitiateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiIapInitiate(iapInitiateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiIapInitiate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LogPaymentFunnelEventBody} logPaymentFunnelEventBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiLogPaymentFunnelEvent(logPaymentFunnelEventBody: LogPaymentFunnelEventBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiLogPaymentFunnelEvent(logPaymentFunnelEventBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiLogPaymentFunnelEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CartCheckoutBody} cartCheckoutBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiMakePayment(cartCheckoutBody: CartCheckoutBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartCheckoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiMakePayment(cartCheckoutBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiMakePayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [discountPercents] 
         * @param {string | null} [itemId] 
         * @param {number | null} [loginWithinDays] 
         * @param {number | null} [maxCredits] 
         * @param {number | null} [minLogins] 
         * @param {number | null} [offerHours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiPremiumPromoPreflight(discountPercents?: string | null, itemId?: string | null, loginWithinDays?: number | null, maxCredits?: number | null, minLogins?: number | null, offerHours?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PremiumPromoPreflightResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiPremiumPromoPreflight(discountPercents, itemId, loginWithinDays, maxCredits, minLogins, offerHours, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiPremiumPromoPreflight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number | null} [discountPercent] 
         * @param {string | null} [itemId] 
         * @param {number | null} [offerHours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiPremiumPromoPreview(discountPercent?: number | null, itemId?: string | null, offerHours?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PremiumPromoPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiPremiumPromoPreview(discountPercent, itemId, offerHours, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiPremiumPromoPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiRedeliverOrder(transactionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedeliverOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiRedeliverOrder(transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiRedeliverOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiRefreshStoreItemAppleStatus(itemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemSyncStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiRefreshStoreItemAppleStatus(itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiRefreshStoreItemAppleStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiRestoreMySubscription(subscriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestoreSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiRestoreMySubscription(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiRestoreMySubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PremiumPromoSendBody} premiumPromoSendBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiSendPremiumPromoEmail(premiumPromoSendBody: PremiumPromoSendBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PremiumPromoSendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiSendPremiumPromoEmail(premiumPromoSendBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiSendPremiumPromoEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiSubmitStoreItemAppleReview(itemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemSyncStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiSubmitStoreItemAppleReview(itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiSubmitStoreItemAppleReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} itemId 
         * @param {SyncStoreItemBody} syncStoreItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiSyncStoreItem(itemId: string, syncStoreItemBody: SyncStoreItemBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiSyncStoreItem(itemId, syncStoreItemBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiSyncStoreItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<UpdateCartBody>} updateCartBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiUpdateCartItems(updateCartBody: Array<UpdateCartBody>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiUpdateCartItems(updateCartBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiUpdateCartItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} itemId 
         * @param {AddNewStoreItemBody} addNewStoreItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiUpdatePurchasableItems(itemId: string, addNewStoreItemBody: AddNewStoreItemBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateStoreItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiUpdatePurchasableItems(itemId, addNewStoreItemBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiUpdatePurchasableItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {AdminUpdateTrasnsactionBody} adminUpdateTrasnsactionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiUpdateTransactionDetails(transactionId: string, adminUpdateTrasnsactionBody: AdminUpdateTrasnsactionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUpdateTrasnsactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiUpdateTransactionDetails(transactionId, adminUpdateTrasnsactionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiUpdateTransactionDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiUploadItemImage(imageFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadItemImageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiUploadItemImage(imageFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiUploadItemImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} transactionId 
         * @param {File | null} [imageFile] 
         * @param {string} [description] 
         * @param {string | null} [giftCardCode] 
         * @param {string | null} [pin] 
         * @param {string | null} [expiresAt] 
         * @param {string | null} [redemptionLink] 
         * @param {boolean} [removeImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiUploadOrderVoucher(transactionId: string, imageFile?: File | null, description?: string, giftCardCode?: string | null, pin?: string | null, expiresAt?: string | null, redemptionLink?: string | null, removeImage?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderVoucherResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiUploadOrderVoucher(transactionId, imageFile, description, giftCardCode, pin, expiresAt, redemptionLink, removeImage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiUploadOrderVoucher']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} itemId 
         * @param {File} [imageFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiUploadStoreItemAppleReviewScreenshot(itemId: string, imageFile?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemSyncStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiUploadStoreItemAppleReviewScreenshot(itemId, imageFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiUploadStoreItemAppleReviewScreenshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertAddressBody} upsertAddressBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiUpsertUserAddressDetails(upsertAddressBody: UpsertAddressBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiUpsertUserAddressDetails(upsertAddressBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiUpsertUserAddressDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertShippingAddressBody} upsertShippingAddressBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiUpsertUserShippingDetails(upsertShippingAddressBody: UpsertShippingAddressBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertShippingAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiUpsertUserShippingDetails(upsertShippingAddressBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiUpsertUserShippingDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserOfferResponseBody} userOfferResponseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiUserOfferItemResponse(userOfferResponseBody: UserOfferResponseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiUserOfferItemResponse(userOfferResponseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiUserOfferItemResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentApiUserOrderHistory(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCartResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentApiUserOrderHistory(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApiApi.paymentApiUserOrderHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentApiApi - factory interface
 */
export const PaymentApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentApiApiFp(configuration)
    return {
        /**
         * 
         * @param {PaymentApiApiPaymentApiAbandonSubscriptionRestoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAbandonSubscriptionRestore(requestParameters: PaymentApiApiPaymentApiAbandonSubscriptionRestoreRequest, options?: RawAxiosRequestConfig): AxiosPromise<AbandonSubscriptionRestoreResponse> {
            return localVarFp.paymentApiAbandonSubscriptionRestore(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiAddItemToCartRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAddItemToCart(requestParameters: PaymentApiApiPaymentApiAddItemToCartRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddItemToCartResponse> {
            return localVarFp.paymentApiAddItemToCart(requestParameters.addItemToCartInBulk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiAddNewItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAddNewItem(requestParameters: PaymentApiApiPaymentApiAddNewItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddNewStoreItemResponse> {
            return localVarFp.paymentApiAddNewItem(requestParameters.addNewStoreItemBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiAdminCreateInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminCreateInvoice(requestParameters: PaymentApiApiPaymentApiAdminCreateInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.paymentApiAdminCreateInvoice(requestParameters.adminCreateInvoice, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiAdminExcludeFromInvoiceSeriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminExcludeFromInvoiceSeries(requestParameters: PaymentApiApiPaymentApiAdminExcludeFromInvoiceSeriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminExcludeFromInvoiceSeriesResponse> {
            return localVarFp.paymentApiAdminExcludeFromInvoiceSeries(requestParameters.adminExcludeFromInvoiceSeriesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiAdminGetUserShippingDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminGetUserShippingDetails(requestParameters: PaymentApiApiPaymentApiAdminGetUserShippingDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpsertAddressResponse> {
            return localVarFp.paymentApiAdminGetUserShippingDetails(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiAdminListSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminListSubscriptions(requestParameters: PaymentApiApiPaymentApiAdminListSubscriptionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminSubscriptionsResponse> {
            return localVarFp.paymentApiAdminListSubscriptions(requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.userSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminReconcileSubscriptions(options?: RawAxiosRequestConfig): AxiosPromise<ReconcileSubscriptionsResponse> {
            return localVarFp.paymentApiAdminReconcileSubscriptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiAdminSupportRedeemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminSupportRedeem(requestParameters: PaymentApiApiPaymentApiAdminSupportRedeemRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSupportRedeemResponse> {
            return localVarFp.paymentApiAdminSupportRedeem(requestParameters.adminSupportRedeemBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiAdminSyncSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiAdminSyncSubscription(requestParameters: PaymentApiApiPaymentApiAdminSyncSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SyncSubscriptionResponse> {
            return localVarFp.paymentApiAdminSyncSubscription(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiBackfillPaymentResults(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.paymentApiBackfillPaymentResults(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiBuySpotlightWithCreditsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiBuySpotlightWithCredits(requestParameters: PaymentApiApiPaymentApiBuySpotlightWithCreditsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BuySpotlightWithCreditsResponse> {
            return localVarFp.paymentApiBuySpotlightWithCredits(requestParameters.buySpotlightWithCreditsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiCancelMySubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiCancelMySubscription(requestParameters: PaymentApiApiPaymentApiCancelMySubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CancelSubscriptionResponse> {
            return localVarFp.paymentApiCancelMySubscription(requestParameters.subscriptionId, requestParameters.cancelSubscriptionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiCancelTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiCancelTransaction(requestParameters: PaymentApiApiPaymentApiCancelTransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CancelPaymentResponse> {
            return localVarFp.paymentApiCancelTransaction(requestParameters.cancelPaymentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiClaimOrderVoucherRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiClaimOrderVoucher(requestParameters: PaymentApiApiPaymentApiClaimOrderVoucherRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimOrderVoucherResponse> {
            return localVarFp.paymentApiClaimOrderVoucher(requestParameters.transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiCompleteTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiCompleteTransaction(requestParameters: PaymentApiApiPaymentApiCompleteTransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CancelPaymentResponse> {
            return localVarFp.paymentApiCompleteTransaction(requestParameters.finishPaymentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiConfirmExternalSubscriptionCancelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiConfirmExternalSubscriptionCancel(requestParameters: PaymentApiApiPaymentApiConfirmExternalSubscriptionCancelRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConfirmExternalCancelResponse> {
            return localVarFp.paymentApiConfirmExternalSubscriptionCancel(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiDeleteCartItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiDeleteCartItem(requestParameters: PaymentApiApiPaymentApiDeleteCartItemRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.paymentApiDeleteCartItem(requestParameters.cartItemId, requestParameters.quantity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiDeleteItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiDeleteItem(requestParameters: PaymentApiApiPaymentApiDeleteItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.paymentApiDeleteItem(requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiGetAdminOrderInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetAdminOrderInvoice(requestParameters: PaymentApiApiPaymentApiGetAdminOrderInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentApiGetAdminOrderInvoice(requestParameters.kind, requestParameters.transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiGetAllItemsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetAllItemsAdmin(requestParameters: PaymentApiApiPaymentApiGetAllItemsAdminRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetStoreItemsAdminResponse> {
            return localVarFp.paymentApiGetAllItemsAdmin(requestParameters.availableTo, requestParameters.isOfferItem, requestParameters.isReward, requestParameters.itemId, requestParameters.itemType, requestParameters.untyped, requestParameters.userSearchQuery, requestParameters.webIsActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiGetAllItemsPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetAllItemsPublic(requestParameters: PaymentApiApiPaymentApiGetAllItemsPublicRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetStoreItemsResponse> {
            return localVarFp.paymentApiGetAllItemsPublic(requestParameters.availableTo, requestParameters.itemId, requestParameters.offerMoment, requestParameters.openOffer, requestParameters.planId, requestParameters.platform, requestParameters.showActiveOffers, requestParameters.showAll, requestParameters.supportsSubscription, requestParameters.userSearchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiGetAllJobItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetAllJobItems(requestParameters: PaymentApiApiPaymentApiGetAllJobItemsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetJobItemResponse> {
            return localVarFp.paymentApiGetAllJobItems(requestParameters.couponCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiGetAllOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetAllOrders(requestParameters: PaymentApiApiPaymentApiGetAllOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminOrdersResponse> {
            return localVarFp.paymentApiGetAllOrders(requestParameters.endDate, requestParameters.pageNo, requestParameters.pageSize, requestParameters.paymentMode, requestParameters.paymentStatus, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetCart(options?: RawAxiosRequestConfig): AxiosPromise<GetCartResponse> {
            return localVarFp.paymentApiGetCart(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetMySubscription(options?: RawAxiosRequestConfig): AxiosPromise<GetMySubscriptionResponse> {
            return localVarFp.paymentApiGetMySubscription(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiGetOrderByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetOrderById(requestParameters: PaymentApiApiPaymentApiGetOrderByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminOrdersByTrasnsactionIdResponse> {
            return localVarFp.paymentApiGetOrderById(requestParameters.transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetOrderVoucherStats(options?: RawAxiosRequestConfig): AxiosPromise<GetVoucherStatsResponse> {
            return localVarFp.paymentApiGetOrderVoucherStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiGetOrgTransactionsDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetOrgTransactionsData(requestParameters: PaymentApiApiPaymentApiGetOrgTransactionsDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOrgTransactionsDataResponse> {
            return localVarFp.paymentApiGetOrgTransactionsData(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiGetSpotlightPurchaseSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetSpotlightPurchaseSummary(requestParameters: PaymentApiApiPaymentApiGetSpotlightPurchaseSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSpotlightPurchaseSummaryResponse> {
            return localVarFp.paymentApiGetSpotlightPurchaseSummary(requestParameters.transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetSpotlightSocialProof(options?: RawAxiosRequestConfig): AxiosPromise<GetSpotlightSocialProofResponse> {
            return localVarFp.paymentApiGetSpotlightSocialProof(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiGetStoreItemSyncStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetStoreItemSyncStatus(requestParameters: PaymentApiApiPaymentApiGetStoreItemSyncStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ItemSyncStatusResponse> {
            return localVarFp.paymentApiGetStoreItemSyncStatus(requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetStoreItemTypeCounts(options?: RawAxiosRequestConfig): AxiosPromise<GetStoreItemTypeCountsResponse> {
            return localVarFp.paymentApiGetStoreItemTypeCounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiGetSubscriptionInvoicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetSubscriptionInvoices(requestParameters: PaymentApiApiPaymentApiGetSubscriptionInvoicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSubscriptionInvoicesResponse> {
            return localVarFp.paymentApiGetSubscriptionInvoices(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetUserAddressDetails(options?: RawAxiosRequestConfig): AxiosPromise<UpsertAddressResponse> {
            return localVarFp.paymentApiGetUserAddressDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiGetUserShippingDetails(options?: RawAxiosRequestConfig): AxiosPromise<GetShippingAddressResponse> {
            return localVarFp.paymentApiGetUserShippingDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiIapConfirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiIapConfirm(requestParameters: PaymentApiApiPaymentApiIapConfirmRequest, options?: RawAxiosRequestConfig): AxiosPromise<IapConfirmResponse> {
            return localVarFp.paymentApiIapConfirm(requestParameters.iapConfirmBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiIapInitiateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiIapInitiate(requestParameters: PaymentApiApiPaymentApiIapInitiateRequest, options?: RawAxiosRequestConfig): AxiosPromise<IapInitiateResponse> {
            return localVarFp.paymentApiIapInitiate(requestParameters.iapInitiateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiLogPaymentFunnelEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiLogPaymentFunnelEvent(requestParameters: PaymentApiApiPaymentApiLogPaymentFunnelEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.paymentApiLogPaymentFunnelEvent(requestParameters.logPaymentFunnelEventBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiMakePaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiMakePayment(requestParameters: PaymentApiApiPaymentApiMakePaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<CartCheckoutResponse> {
            return localVarFp.paymentApiMakePayment(requestParameters.cartCheckoutBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiPremiumPromoPreflightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiPremiumPromoPreflight(requestParameters: PaymentApiApiPaymentApiPremiumPromoPreflightRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PremiumPromoPreflightResponse> {
            return localVarFp.paymentApiPremiumPromoPreflight(requestParameters.discountPercents, requestParameters.itemId, requestParameters.loginWithinDays, requestParameters.maxCredits, requestParameters.minLogins, requestParameters.offerHours, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiPremiumPromoPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiPremiumPromoPreview(requestParameters: PaymentApiApiPaymentApiPremiumPromoPreviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PremiumPromoPreviewResponse> {
            return localVarFp.paymentApiPremiumPromoPreview(requestParameters.discountPercent, requestParameters.itemId, requestParameters.offerHours, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiRedeliverOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiRedeliverOrder(requestParameters: PaymentApiApiPaymentApiRedeliverOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<RedeliverOrderResponse> {
            return localVarFp.paymentApiRedeliverOrder(requestParameters.transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiRefreshStoreItemAppleStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiRefreshStoreItemAppleStatus(requestParameters: PaymentApiApiPaymentApiRefreshStoreItemAppleStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ItemSyncStatusResponse> {
            return localVarFp.paymentApiRefreshStoreItemAppleStatus(requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiRestoreMySubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiRestoreMySubscription(requestParameters: PaymentApiApiPaymentApiRestoreMySubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<RestoreSubscriptionResponse> {
            return localVarFp.paymentApiRestoreMySubscription(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiSendPremiumPromoEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiSendPremiumPromoEmail(requestParameters: PaymentApiApiPaymentApiSendPremiumPromoEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<PremiumPromoSendResponse> {
            return localVarFp.paymentApiSendPremiumPromoEmail(requestParameters.premiumPromoSendBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiSubmitStoreItemAppleReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiSubmitStoreItemAppleReview(requestParameters: PaymentApiApiPaymentApiSubmitStoreItemAppleReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<ItemSyncStatusResponse> {
            return localVarFp.paymentApiSubmitStoreItemAppleReview(requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiSyncStoreItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiSyncStoreItem(requestParameters: PaymentApiApiPaymentApiSyncStoreItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.paymentApiSyncStoreItem(requestParameters.itemId, requestParameters.syncStoreItemBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiUpdateCartItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUpdateCartItems(requestParameters: PaymentApiApiPaymentApiUpdateCartItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCartResponse> {
            return localVarFp.paymentApiUpdateCartItems(requestParameters.updateCartBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiUpdatePurchasableItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUpdatePurchasableItems(requestParameters: PaymentApiApiPaymentApiUpdatePurchasableItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateStoreItemResponse> {
            return localVarFp.paymentApiUpdatePurchasableItems(requestParameters.itemId, requestParameters.addNewStoreItemBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiUpdateTransactionDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUpdateTransactionDetails(requestParameters: PaymentApiApiPaymentApiUpdateTransactionDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUpdateTrasnsactionResponse> {
            return localVarFp.paymentApiUpdateTransactionDetails(requestParameters.transactionId, requestParameters.adminUpdateTrasnsactionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiUploadItemImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUploadItemImage(requestParameters: PaymentApiApiPaymentApiUploadItemImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadItemImageResponse> {
            return localVarFp.paymentApiUploadItemImage(requestParameters.imageFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiUploadOrderVoucherRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUploadOrderVoucher(requestParameters: PaymentApiApiPaymentApiUploadOrderVoucherRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderVoucherResponse> {
            return localVarFp.paymentApiUploadOrderVoucher(requestParameters.transactionId, requestParameters.imageFile, requestParameters.description, requestParameters.giftCardCode, requestParameters.pin, requestParameters.expiresAt, requestParameters.redemptionLink, requestParameters.removeImage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiUploadStoreItemAppleReviewScreenshotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUploadStoreItemAppleReviewScreenshot(requestParameters: PaymentApiApiPaymentApiUploadStoreItemAppleReviewScreenshotRequest, options?: RawAxiosRequestConfig): AxiosPromise<ItemSyncStatusResponse> {
            return localVarFp.paymentApiUploadStoreItemAppleReviewScreenshot(requestParameters.itemId, requestParameters.imageFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiUpsertUserAddressDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUpsertUserAddressDetails(requestParameters: PaymentApiApiPaymentApiUpsertUserAddressDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpsertAddressResponse> {
            return localVarFp.paymentApiUpsertUserAddressDetails(requestParameters.upsertAddressBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiUpsertUserShippingDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUpsertUserShippingDetails(requestParameters: PaymentApiApiPaymentApiUpsertUserShippingDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpsertShippingAddressResponse> {
            return localVarFp.paymentApiUpsertUserShippingDetails(requestParameters.upsertShippingAddressBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiApiPaymentApiUserOfferItemResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUserOfferItemResponse(requestParameters: PaymentApiApiPaymentApiUserOfferItemResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.paymentApiUserOfferItemResponse(requestParameters.userOfferResponseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentApiUserOrderHistory(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCartResponse>> {
            return localVarFp.paymentApiUserOrderHistory(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for paymentApiAbandonSubscriptionRestore operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiAbandonSubscriptionRestoreRequest {
    readonly subscriptionId: string
}

/**
 * Request parameters for paymentApiAddItemToCart operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiAddItemToCartRequest {
    readonly addItemToCartInBulk: AddItemToCartInBulk
}

/**
 * Request parameters for paymentApiAddNewItem operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiAddNewItemRequest {
    readonly addNewStoreItemBody: AddNewStoreItemBody
}

/**
 * Request parameters for paymentApiAdminCreateInvoice operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiAdminCreateInvoiceRequest {
    readonly adminCreateInvoice: AdminCreateInvoice
}

/**
 * Request parameters for paymentApiAdminExcludeFromInvoiceSeries operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiAdminExcludeFromInvoiceSeriesRequest {
    readonly adminExcludeFromInvoiceSeriesBody: AdminExcludeFromInvoiceSeriesBody
}

/**
 * Request parameters for paymentApiAdminGetUserShippingDetails operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiAdminGetUserShippingDetailsRequest {
    readonly userId: string
}

/**
 * Request parameters for paymentApiAdminListSubscriptions operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiAdminListSubscriptionsRequest {
    readonly page?: number | null

    readonly pageSize?: number | null

    readonly status?: PaymentApiAdminListSubscriptionsStatusEnum

    readonly userSearch?: string | null
}

/**
 * Request parameters for paymentApiAdminSupportRedeem operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiAdminSupportRedeemRequest {
    readonly adminSupportRedeemBody: AdminSupportRedeemBody
}

/**
 * Request parameters for paymentApiAdminSyncSubscription operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiAdminSyncSubscriptionRequest {
    readonly subscriptionId: string
}

/**
 * Request parameters for paymentApiBuySpotlightWithCredits operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiBuySpotlightWithCreditsRequest {
    readonly buySpotlightWithCreditsBody: BuySpotlightWithCreditsBody
}

/**
 * Request parameters for paymentApiCancelMySubscription operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiCancelMySubscriptionRequest {
    readonly subscriptionId: string

    readonly cancelSubscriptionBody: CancelSubscriptionBody
}

/**
 * Request parameters for paymentApiCancelTransaction operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiCancelTransactionRequest {
    readonly cancelPaymentBody: CancelPaymentBody
}

/**
 * Request parameters for paymentApiClaimOrderVoucher operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiClaimOrderVoucherRequest {
    readonly transactionId: string
}

/**
 * Request parameters for paymentApiCompleteTransaction operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiCompleteTransactionRequest {
    readonly finishPaymentBody: FinishPaymentBody
}

/**
 * Request parameters for paymentApiConfirmExternalSubscriptionCancel operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiConfirmExternalSubscriptionCancelRequest {
    readonly subscriptionId: string
}

/**
 * Request parameters for paymentApiDeleteCartItem operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiDeleteCartItemRequest {
    readonly cartItemId?: string

    readonly quantity?: number
}

/**
 * Request parameters for paymentApiDeleteItem operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiDeleteItemRequest {
    readonly itemId: string
}

/**
 * Request parameters for paymentApiGetAdminOrderInvoice operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiGetAdminOrderInvoiceRequest {
    readonly kind: PaymentApiGetAdminOrderInvoiceKindEnum

    readonly transactionId: string
}

/**
 * Request parameters for paymentApiGetAllItemsAdmin operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiGetAllItemsAdminRequest {
    readonly availableTo?: PaymentApiGetAllItemsAdminAvailableToEnum

    readonly isOfferItem?: boolean | null

    readonly isReward?: boolean | null

    readonly itemId?: string

    readonly itemType?: PaymentApiGetAllItemsAdminItemTypeEnum

    readonly untyped?: boolean | null

    readonly userSearchQuery?: string

    readonly webIsActive?: boolean | null
}

/**
 * Request parameters for paymentApiGetAllItemsPublic operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiGetAllItemsPublicRequest {
    readonly availableTo?: string

    readonly itemId?: string

    readonly offerMoment?: PaymentApiGetAllItemsPublicOfferMomentEnum

    readonly openOffer?: boolean

    readonly planId?: string | null

    readonly platform?: string | null

    readonly showActiveOffers?: boolean

    readonly showAll?: boolean | null

    readonly supportsSubscription?: boolean

    readonly userSearchQuery?: string
}

/**
 * Request parameters for paymentApiGetAllJobItems operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiGetAllJobItemsRequest {
    readonly couponCode?: string
}

/**
 * Request parameters for paymentApiGetAllOrders operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiGetAllOrdersRequest {
    readonly endDate?: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly paymentMode?: string

    readonly paymentStatus?: string

    readonly startDate?: string
}

/**
 * Request parameters for paymentApiGetOrderById operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiGetOrderByIdRequest {
    readonly transactionId: string
}

/**
 * Request parameters for paymentApiGetOrgTransactionsData operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiGetOrgTransactionsDataRequest {
    readonly orgId: string
}

/**
 * Request parameters for paymentApiGetSpotlightPurchaseSummary operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiGetSpotlightPurchaseSummaryRequest {
    readonly transactionId: string
}

/**
 * Request parameters for paymentApiGetStoreItemSyncStatus operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiGetStoreItemSyncStatusRequest {
    readonly itemId: string
}

/**
 * Request parameters for paymentApiGetSubscriptionInvoices operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiGetSubscriptionInvoicesRequest {
    readonly subscriptionId: string
}

/**
 * Request parameters for paymentApiIapConfirm operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiIapConfirmRequest {
    readonly iapConfirmBody: IapConfirmBody
}

/**
 * Request parameters for paymentApiIapInitiate operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiIapInitiateRequest {
    readonly iapInitiateBody: IapInitiateBody
}

/**
 * Request parameters for paymentApiLogPaymentFunnelEvent operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiLogPaymentFunnelEventRequest {
    readonly logPaymentFunnelEventBody: LogPaymentFunnelEventBody
}

/**
 * Request parameters for paymentApiMakePayment operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiMakePaymentRequest {
    readonly cartCheckoutBody: CartCheckoutBody
}

/**
 * Request parameters for paymentApiPremiumPromoPreflight operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiPremiumPromoPreflightRequest {
    readonly discountPercents?: string | null

    readonly itemId?: string | null

    readonly loginWithinDays?: number | null

    readonly maxCredits?: number | null

    readonly minLogins?: number | null

    readonly offerHours?: number | null
}

/**
 * Request parameters for paymentApiPremiumPromoPreview operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiPremiumPromoPreviewRequest {
    readonly discountPercent?: number | null

    readonly itemId?: string | null

    readonly offerHours?: number | null
}

/**
 * Request parameters for paymentApiRedeliverOrder operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiRedeliverOrderRequest {
    readonly transactionId: string
}

/**
 * Request parameters for paymentApiRefreshStoreItemAppleStatus operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiRefreshStoreItemAppleStatusRequest {
    readonly itemId: string
}

/**
 * Request parameters for paymentApiRestoreMySubscription operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiRestoreMySubscriptionRequest {
    readonly subscriptionId: string
}

/**
 * Request parameters for paymentApiSendPremiumPromoEmail operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiSendPremiumPromoEmailRequest {
    readonly premiumPromoSendBody: PremiumPromoSendBody
}

/**
 * Request parameters for paymentApiSubmitStoreItemAppleReview operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiSubmitStoreItemAppleReviewRequest {
    readonly itemId: string
}

/**
 * Request parameters for paymentApiSyncStoreItem operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiSyncStoreItemRequest {
    readonly itemId: string

    readonly syncStoreItemBody: SyncStoreItemBody
}

/**
 * Request parameters for paymentApiUpdateCartItems operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiUpdateCartItemsRequest {
    readonly updateCartBody: Array<UpdateCartBody>
}

/**
 * Request parameters for paymentApiUpdatePurchasableItems operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiUpdatePurchasableItemsRequest {
    readonly itemId: string

    readonly addNewStoreItemBody: AddNewStoreItemBody
}

/**
 * Request parameters for paymentApiUpdateTransactionDetails operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiUpdateTransactionDetailsRequest {
    readonly transactionId: string

    readonly adminUpdateTrasnsactionBody: AdminUpdateTrasnsactionBody
}

/**
 * Request parameters for paymentApiUploadItemImage operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiUploadItemImageRequest {
    readonly imageFile: File
}

/**
 * Request parameters for paymentApiUploadOrderVoucher operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiUploadOrderVoucherRequest {
    readonly transactionId: string

    readonly imageFile?: File | null

    readonly description?: string

    readonly giftCardCode?: string | null

    readonly pin?: string | null

    readonly expiresAt?: string | null

    readonly redemptionLink?: string | null

    readonly removeImage?: boolean
}

/**
 * Request parameters for paymentApiUploadStoreItemAppleReviewScreenshot operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiUploadStoreItemAppleReviewScreenshotRequest {
    readonly itemId: string

    readonly imageFile?: File
}

/**
 * Request parameters for paymentApiUpsertUserAddressDetails operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiUpsertUserAddressDetailsRequest {
    readonly upsertAddressBody: UpsertAddressBody
}

/**
 * Request parameters for paymentApiUpsertUserShippingDetails operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiUpsertUserShippingDetailsRequest {
    readonly upsertShippingAddressBody: UpsertShippingAddressBody
}

/**
 * Request parameters for paymentApiUserOfferItemResponse operation in PaymentApiApi.
 */
export interface PaymentApiApiPaymentApiUserOfferItemResponseRequest {
    readonly userOfferResponseBody: UserOfferResponseBody
}

/**
 * PaymentApiApi - object-oriented interface
 */
export class PaymentApiApi extends BaseAPI {
    /**
     * 
     * @param {PaymentApiApiPaymentApiAbandonSubscriptionRestoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiAbandonSubscriptionRestore(requestParameters: PaymentApiApiPaymentApiAbandonSubscriptionRestoreRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiAbandonSubscriptionRestore(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiAddItemToCartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiAddItemToCart(requestParameters: PaymentApiApiPaymentApiAddItemToCartRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiAddItemToCart(requestParameters.addItemToCartInBulk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiAddNewItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiAddNewItem(requestParameters: PaymentApiApiPaymentApiAddNewItemRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiAddNewItem(requestParameters.addNewStoreItemBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiAdminCreateInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiAdminCreateInvoice(requestParameters: PaymentApiApiPaymentApiAdminCreateInvoiceRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiAdminCreateInvoice(requestParameters.adminCreateInvoice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiAdminExcludeFromInvoiceSeriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiAdminExcludeFromInvoiceSeries(requestParameters: PaymentApiApiPaymentApiAdminExcludeFromInvoiceSeriesRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiAdminExcludeFromInvoiceSeries(requestParameters.adminExcludeFromInvoiceSeriesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiAdminGetUserShippingDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiAdminGetUserShippingDetails(requestParameters: PaymentApiApiPaymentApiAdminGetUserShippingDetailsRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiAdminGetUserShippingDetails(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiAdminListSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiAdminListSubscriptions(requestParameters: PaymentApiApiPaymentApiAdminListSubscriptionsRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiAdminListSubscriptions(requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.userSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiAdminReconcileSubscriptions(options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiAdminReconcileSubscriptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiAdminSupportRedeemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiAdminSupportRedeem(requestParameters: PaymentApiApiPaymentApiAdminSupportRedeemRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiAdminSupportRedeem(requestParameters.adminSupportRedeemBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiAdminSyncSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiAdminSyncSubscription(requestParameters: PaymentApiApiPaymentApiAdminSyncSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiAdminSyncSubscription(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiBackfillPaymentResults(options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiBackfillPaymentResults(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiBuySpotlightWithCreditsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiBuySpotlightWithCredits(requestParameters: PaymentApiApiPaymentApiBuySpotlightWithCreditsRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiBuySpotlightWithCredits(requestParameters.buySpotlightWithCreditsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiCancelMySubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiCancelMySubscription(requestParameters: PaymentApiApiPaymentApiCancelMySubscriptionRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiCancelMySubscription(requestParameters.subscriptionId, requestParameters.cancelSubscriptionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiCancelTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiCancelTransaction(requestParameters: PaymentApiApiPaymentApiCancelTransactionRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiCancelTransaction(requestParameters.cancelPaymentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiClaimOrderVoucherRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiClaimOrderVoucher(requestParameters: PaymentApiApiPaymentApiClaimOrderVoucherRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiClaimOrderVoucher(requestParameters.transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiCompleteTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiCompleteTransaction(requestParameters: PaymentApiApiPaymentApiCompleteTransactionRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiCompleteTransaction(requestParameters.finishPaymentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiConfirmExternalSubscriptionCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiConfirmExternalSubscriptionCancel(requestParameters: PaymentApiApiPaymentApiConfirmExternalSubscriptionCancelRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiConfirmExternalSubscriptionCancel(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiDeleteCartItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiDeleteCartItem(requestParameters: PaymentApiApiPaymentApiDeleteCartItemRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiDeleteCartItem(requestParameters.cartItemId, requestParameters.quantity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiDeleteItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiDeleteItem(requestParameters: PaymentApiApiPaymentApiDeleteItemRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiDeleteItem(requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiGetAdminOrderInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetAdminOrderInvoice(requestParameters: PaymentApiApiPaymentApiGetAdminOrderInvoiceRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetAdminOrderInvoice(requestParameters.kind, requestParameters.transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiGetAllItemsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetAllItemsAdmin(requestParameters: PaymentApiApiPaymentApiGetAllItemsAdminRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetAllItemsAdmin(requestParameters.availableTo, requestParameters.isOfferItem, requestParameters.isReward, requestParameters.itemId, requestParameters.itemType, requestParameters.untyped, requestParameters.userSearchQuery, requestParameters.webIsActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiGetAllItemsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetAllItemsPublic(requestParameters: PaymentApiApiPaymentApiGetAllItemsPublicRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetAllItemsPublic(requestParameters.availableTo, requestParameters.itemId, requestParameters.offerMoment, requestParameters.openOffer, requestParameters.planId, requestParameters.platform, requestParameters.showActiveOffers, requestParameters.showAll, requestParameters.supportsSubscription, requestParameters.userSearchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiGetAllJobItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetAllJobItems(requestParameters: PaymentApiApiPaymentApiGetAllJobItemsRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetAllJobItems(requestParameters.couponCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiGetAllOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetAllOrders(requestParameters: PaymentApiApiPaymentApiGetAllOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetAllOrders(requestParameters.endDate, requestParameters.pageNo, requestParameters.pageSize, requestParameters.paymentMode, requestParameters.paymentStatus, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetCart(options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetCart(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetMySubscription(options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetMySubscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiGetOrderByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetOrderById(requestParameters: PaymentApiApiPaymentApiGetOrderByIdRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetOrderById(requestParameters.transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetOrderVoucherStats(options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetOrderVoucherStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiGetOrgTransactionsDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetOrgTransactionsData(requestParameters: PaymentApiApiPaymentApiGetOrgTransactionsDataRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetOrgTransactionsData(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiGetSpotlightPurchaseSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetSpotlightPurchaseSummary(requestParameters: PaymentApiApiPaymentApiGetSpotlightPurchaseSummaryRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetSpotlightPurchaseSummary(requestParameters.transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetSpotlightSocialProof(options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetSpotlightSocialProof(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiGetStoreItemSyncStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetStoreItemSyncStatus(requestParameters: PaymentApiApiPaymentApiGetStoreItemSyncStatusRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetStoreItemSyncStatus(requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetStoreItemTypeCounts(options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetStoreItemTypeCounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiGetSubscriptionInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetSubscriptionInvoices(requestParameters: PaymentApiApiPaymentApiGetSubscriptionInvoicesRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetSubscriptionInvoices(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetUserAddressDetails(options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetUserAddressDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiGetUserShippingDetails(options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiGetUserShippingDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiIapConfirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiIapConfirm(requestParameters: PaymentApiApiPaymentApiIapConfirmRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiIapConfirm(requestParameters.iapConfirmBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiIapInitiateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiIapInitiate(requestParameters: PaymentApiApiPaymentApiIapInitiateRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiIapInitiate(requestParameters.iapInitiateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiLogPaymentFunnelEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiLogPaymentFunnelEvent(requestParameters: PaymentApiApiPaymentApiLogPaymentFunnelEventRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiLogPaymentFunnelEvent(requestParameters.logPaymentFunnelEventBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiMakePaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiMakePayment(requestParameters: PaymentApiApiPaymentApiMakePaymentRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiMakePayment(requestParameters.cartCheckoutBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiPremiumPromoPreflightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiPremiumPromoPreflight(requestParameters: PaymentApiApiPaymentApiPremiumPromoPreflightRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiPremiumPromoPreflight(requestParameters.discountPercents, requestParameters.itemId, requestParameters.loginWithinDays, requestParameters.maxCredits, requestParameters.minLogins, requestParameters.offerHours, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiPremiumPromoPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiPremiumPromoPreview(requestParameters: PaymentApiApiPaymentApiPremiumPromoPreviewRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiPremiumPromoPreview(requestParameters.discountPercent, requestParameters.itemId, requestParameters.offerHours, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiRedeliverOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiRedeliverOrder(requestParameters: PaymentApiApiPaymentApiRedeliverOrderRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiRedeliverOrder(requestParameters.transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiRefreshStoreItemAppleStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiRefreshStoreItemAppleStatus(requestParameters: PaymentApiApiPaymentApiRefreshStoreItemAppleStatusRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiRefreshStoreItemAppleStatus(requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiRestoreMySubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiRestoreMySubscription(requestParameters: PaymentApiApiPaymentApiRestoreMySubscriptionRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiRestoreMySubscription(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiSendPremiumPromoEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiSendPremiumPromoEmail(requestParameters: PaymentApiApiPaymentApiSendPremiumPromoEmailRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiSendPremiumPromoEmail(requestParameters.premiumPromoSendBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiSubmitStoreItemAppleReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiSubmitStoreItemAppleReview(requestParameters: PaymentApiApiPaymentApiSubmitStoreItemAppleReviewRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiSubmitStoreItemAppleReview(requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiSyncStoreItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiSyncStoreItem(requestParameters: PaymentApiApiPaymentApiSyncStoreItemRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiSyncStoreItem(requestParameters.itemId, requestParameters.syncStoreItemBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiUpdateCartItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiUpdateCartItems(requestParameters: PaymentApiApiPaymentApiUpdateCartItemsRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiUpdateCartItems(requestParameters.updateCartBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiUpdatePurchasableItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiUpdatePurchasableItems(requestParameters: PaymentApiApiPaymentApiUpdatePurchasableItemsRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiUpdatePurchasableItems(requestParameters.itemId, requestParameters.addNewStoreItemBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiUpdateTransactionDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiUpdateTransactionDetails(requestParameters: PaymentApiApiPaymentApiUpdateTransactionDetailsRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiUpdateTransactionDetails(requestParameters.transactionId, requestParameters.adminUpdateTrasnsactionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiUploadItemImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiUploadItemImage(requestParameters: PaymentApiApiPaymentApiUploadItemImageRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiUploadItemImage(requestParameters.imageFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiUploadOrderVoucherRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiUploadOrderVoucher(requestParameters: PaymentApiApiPaymentApiUploadOrderVoucherRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiUploadOrderVoucher(requestParameters.transactionId, requestParameters.imageFile, requestParameters.description, requestParameters.giftCardCode, requestParameters.pin, requestParameters.expiresAt, requestParameters.redemptionLink, requestParameters.removeImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiUploadStoreItemAppleReviewScreenshotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiUploadStoreItemAppleReviewScreenshot(requestParameters: PaymentApiApiPaymentApiUploadStoreItemAppleReviewScreenshotRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiUploadStoreItemAppleReviewScreenshot(requestParameters.itemId, requestParameters.imageFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiUpsertUserAddressDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiUpsertUserAddressDetails(requestParameters: PaymentApiApiPaymentApiUpsertUserAddressDetailsRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiUpsertUserAddressDetails(requestParameters.upsertAddressBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiUpsertUserShippingDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiUpsertUserShippingDetails(requestParameters: PaymentApiApiPaymentApiUpsertUserShippingDetailsRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiUpsertUserShippingDetails(requestParameters.upsertShippingAddressBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiApiPaymentApiUserOfferItemResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiUserOfferItemResponse(requestParameters: PaymentApiApiPaymentApiUserOfferItemResponseRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiUserOfferItemResponse(requestParameters.userOfferResponseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public paymentApiUserOrderHistory(options?: RawAxiosRequestConfig) {
        return PaymentApiApiFp(this.configuration).paymentApiUserOrderHistory(options).then((request) => request(this.axios, this.basePath));
    }
}

export const PaymentApiAdminListSubscriptionsStatusEnum = {
    Created: 'created',
    Authenticated: 'authenticated',
    Active: 'active',
    Pending: 'pending',
    Halted: 'halted',
    Cancelled: 'cancelled',
    Completed: 'completed',
    Expired: 'expired',
    Paused: 'paused',
} as const;
export type PaymentApiAdminListSubscriptionsStatusEnum = typeof PaymentApiAdminListSubscriptionsStatusEnum[keyof typeof PaymentApiAdminListSubscriptionsStatusEnum];
export const PaymentApiGetAdminOrderInvoiceKindEnum = {
    Gst: 'gst',
    Full: 'full',
} as const;
export type PaymentApiGetAdminOrderInvoiceKindEnum = typeof PaymentApiGetAdminOrderInvoiceKindEnum[keyof typeof PaymentApiGetAdminOrderInvoiceKindEnum];
export const PaymentApiGetAllItemsAdminAvailableToEnum = {
    Employers: 'Employers',
    Learners: 'Learners',
    Applicants: 'Applicants',
    All: 'All',
} as const;
export type PaymentApiGetAllItemsAdminAvailableToEnum = typeof PaymentApiGetAllItemsAdminAvailableToEnum[keyof typeof PaymentApiGetAllItemsAdminAvailableToEnum];
export const PaymentApiGetAllItemsAdminItemTypeEnum = {
    Credits: 'credits',
    Mocktests: 'mocktests',
    Giftcards: 'giftcards',
    PostPremiumJobSingle: 'post_premium_job_single',
    PostPremiumJobSubscription: 'post_premium_job_subscription',
    SingleJobAnalysisCredits: 'single_job_analysis_credits',
    JobBundle: 'job_bundle',
    PremiumProfile: 'premium_profile',
    PremiumProfileAppFree: 'premium_profile_app_free',
    PremiumProfileStandard: 'premium_profile_standard',
    PremiumProfilePro: 'premium_profile_pro',
    PremiumProfileLite: 'premium_profile_lite',
    ApplicantSpotlight: 'applicant_spotlight',
    EmployerCreditPack: 'employer_credit_pack',
    Physical: 'physical',
} as const;
export type PaymentApiGetAllItemsAdminItemTypeEnum = typeof PaymentApiGetAllItemsAdminItemTypeEnum[keyof typeof PaymentApiGetAllItemsAdminItemTypeEnum];
export const PaymentApiGetAllItemsPublicOfferMomentEnum = {
    Apply: 'apply',
    Return: 'return',
    LessonDone: 'lesson_done',
    ResumeDownload: 'resume_download',
    MultiplayerDone: 'multiplayer_done',
} as const;
export type PaymentApiGetAllItemsPublicOfferMomentEnum = typeof PaymentApiGetAllItemsPublicOfferMomentEnum[keyof typeof PaymentApiGetAllItemsPublicOfferMomentEnum];
